import { createAction } from '@ngrx/store';

export const AppStatusSetOnline = createAction('[APP_STATUS_ACTION] SET_ONLINE');
export const AppStatusSetOffline = createAction('[APP_STATUS_ACTION] SET_OFFLINE');
